import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ChevronDown, ChevronRight } from "lucide-react";

export const AttentionRollup = ({ items }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState({});
  const groups = [];
  items.forEach((a) => { let g = groups.find((x) => x.issue === a.issue); if (!g) { g = { issue: a.issue, level: a.level, rows: [] }; groups.push(g); } g.rows.push(a); if (a.level === "critical") g.level = "critical"; });
  const expandAll = Object.values(open).filter(Boolean).length < groups.length;
  return (
    <div className="-mx-2" data-testid="attention-rollup">
      <div className="flex justify-end px-2 pb-1">
        <button onClick={() => setOpen(Object.fromEntries(groups.map((g) => [g.issue, expandAll])))} className="text-[11px] font-semibold text-[#377DD3] hover:underline" data-testid="attention-toggle-all">{expandAll ? "Expand all" : "Collapse all"}</button>
      </div>
      <ul className="divide-y divide-[#377DD3]/10">
        {groups.map((g, gi) => { const isOpen = !!open[g.issue]; const crit = g.level === "critical"; return (
          <li key={g.issue}>
            <button onClick={() => setOpen({ ...open, [g.issue]: !isOpen })} className="w-full flex items-center gap-3 px-2 py-3 text-left rounded-xl hover:bg-[#EAF2F8]/70 dark:hover:bg-muted transition-colors" aria-expanded={isOpen} data-testid={`attention-group-${gi}`}>
              <span className={`h-8 w-8 shrink-0 rounded-lg flex items-center justify-center ${crit ? "bg-[#E5484D]/12 text-[#E5484D]" : "bg-[#F5A623]/14 text-[#C77C08]"}`}><AlertTriangle size={15} /></span>
              <div className="min-w-0 flex-1"><p className="text-sm font-semibold text-[#0D1B2A] dark:text-foreground truncate">{g.issue}</p><p className="text-xs text-[#64748B] truncate">{g.rows.slice(0, 3).map((r) => r.ref).join(", ")}{g.rows.length > 3 ? ` +${g.rows.length - 3} more` : ""}</p></div>
              <span className={`hd-num text-xs font-bold rounded-full px-2 py-0.5 ${crit ? "bg-[#E5484D]/12 text-[#E5484D]" : "bg-[#F5A623]/14 text-[#C77C08]"}`} data-testid={`attention-group-count-${gi}`}>{g.rows.length}</span>
              <span className="text-[#64748B]">{isOpen ? <ChevronDown size={15} /> : <ChevronRight size={15} />}</span>
            </button>
            {isOpen && (
              <ul className="pb-2 pl-12 pr-2 space-y-0.5" data-testid={`attention-group-rows-${gi}`}>
                {g.rows.map((a, i) => (
                  <li key={i}><button onClick={() => navigate(a.link)} className="w-full flex items-center justify-between gap-3 rounded-lg px-2 py-1.5 text-left text-sm hover:bg-[#EAF2F8]/70 dark:hover:bg-muted transition-colors" data-testid={`attention-row-${gi}-${i}`}>
                    <span className="font-semibold text-[#0D1B2A] dark:text-foreground truncate">{a.ref}</span>
                    <span className="flex items-center gap-2 shrink-0 text-xs text-[#64748B]">{a.when}<span className="font-semibold text-[#377DD3] inline-flex items-center">View <ChevronRight size={13} /></span></span>
                  </button></li>
                ))}
              </ul>
            )}
          </li>
        ); })}
      </ul>
    </div>
  );
};
